"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderBlockListItems = void 0;
var _react = _interopRequireDefault(require("react"));
var _ProductIntroCards = _interopRequireDefault(require("./ProductIntroCards"));
var _BioBlocks = _interopRequireDefault(require("./BioBlocks"));
var _BoundedCards = _interopRequireDefault(require("./BoundedCards"));
var _IconListItemBlocks = _interopRequireDefault(require("./IconListItemBlocks"));
var _IconMiniBlocks = _interopRequireDefault(require("./IconMiniBlocks"));
var _UnboundedCards = _interopRequireDefault(require("./UnboundedCards"));
var _EcommerceCards = _interopRequireDefault(require("./EcommerceCards"));
var _Video = _interopRequireDefault(require("../Video/Video"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderBlockListItems = (content, type) => {
  switch (type) {
    case "product_intro_cards":
      return /*#__PURE__*/_react.default.createElement(_ProductIntroCards.default, {
        content: content
      });
    case "bounded_cards":
      return /*#__PURE__*/_react.default.createElement(_BoundedCards.default, {
        content: content,
        VideoComponent: _Video.default
      });
    case "unbounded_cards":
      return /*#__PURE__*/_react.default.createElement(_UnboundedCards.default, {
        content: content,
        VideoComponent: _Video.default
      });
    case "ecommerce_cards":
      return /*#__PURE__*/_react.default.createElement(_EcommerceCards.default, {
        content: content
      });
    case "icon_mini_blocks":
      return /*#__PURE__*/_react.default.createElement(_IconMiniBlocks.default, {
        content: content
      });
    case "icon_list_item_blocks":
      return /*#__PURE__*/_react.default.createElement(_IconListItemBlocks.default, {
        content: content,
        VideoComponent: _Video.default
      });
    case "bio_blocks":
      return /*#__PURE__*/_react.default.createElement(_BioBlocks.default, {
        content: content
      });
    default:
      return null;
  }
};
exports.renderBlockListItems = renderBlockListItems;